// import { DEFAULT_RPC } from "@/config";
// import { getProvider } from "@/config/net";
import {
  Contract,
  BigNumberish,
  TransactionRequest,
  // formatUnits,
} from "ethers";

/**
 * 通用函数 - 在 estimateGas 的基础上添加 buffer，避免因网络波动导致的 gas 不足。
 *
 * @param contractInstance  - 目标合约实例 (如 uniswapRouter)
 * @param methodName        - 函数名，如 "addLiquidityETH"
 * @param methodParams      - 该函数对应的参数数组
 * @param overrides         - 额外交易选项（例如 from, value 等）
 * @param bufferRatio       - Buffer 比例，默认 1.2 (多 20%)
 *
 * @returns 返回加了 buffer 的 safeGasLimit
 */
export async function estimateGasWithBuffer(
  contractInstance: Contract,
  methodName: string,
  methodParams: any[],
  overrides: TransactionRequest = {},
  fallbackGasLimit: BigNumberish,
  bufferRatio = 1.2
): Promise<BigNumberish> {
  try {
    // 1) 用合约实例的 estimateGas 方法先获取原始 gas 预估值
    const estimatedGas: BigNumberish = await contractInstance[
      methodName
    ].estimateGas(...methodParams, overrides);

    // 2) 乘以 bufferRatio，加 20% 之类的冗余
    const multiplier = BigInt(Math.round(bufferRatio * 100));
    const safeGasLimit = (estimatedGas * multiplier) / 100n;

    console.log("estimatedGas:", estimatedGas.toString());
    console.log("safeGasLimit:", safeGasLimit.toString());

    return safeGasLimit;
  } catch (error) {
    console.log("error", error);
    return fallbackGasLimit;
  }
}

export function estimateGasWithBufferNew(
  contractInstance: Contract,
  methodName: string,
  methodParams: any[],
  overrides: TransactionRequest = {},
  bufferRatio = 1.2
): Promise<BigNumberish> {
  return new Promise(async(resolve,reject) => {
    try {
      // 1) 用合约实例的 estimateGas 方法先获取原始 gas 预估值
      const estimatedGas: BigNumberish = await contractInstance[
        methodName
      ].estimateGas(...methodParams, overrides);
  
      // 2) 乘以 bufferRatio，加 20% 之类的冗余
      const multiplier = BigInt(Math.round(bufferRatio * 100));
      const safeGasLimit = (estimatedGas * multiplier) / 100n;
      console.log("estimatedGas:", estimatedGas.toString());
      console.log("safeGasLimit:", safeGasLimit.toString());
      resolve(safeGasLimit);
    } catch (error) {
      // console.log("error", error);
      reject(error);
    }
  })  
}

// const provider = getProvider(DEFAULT_RPC);
// const { feeType, fees } = useSelector((state: any) => {
//   return state.projectControll
// })

export async function getEvmFees() {
  // const fees = await provider.getFeeData();
  // return {
  //   gasPrice: fees.gasPrice?.toString() ?? "0",
  //   maxFeePerGas: fees.maxFeePerGas?.toString() ?? "0", 
  //   maxPriorityFeePerGas: fees.maxPriorityFeePerGas?.toString() ?? "0",
  // };

  // const gasPrice = await provider.getGasPrice();
    return {
    gasPrice: "10000000", // 0.01gwei
    maxFeePerGas: "0", 
    maxPriorityFeePerGas: "0",
  };
}

// // 获取用户设置的自定义 gas 价格
// export async function getCustomFeesData() {
//   const { gasPrice, maxFeePerGas, maxPriorityFeePerGas } = fees;
//   return {
//     gasPrice: BigInt(gasPrice) * BigInt(feeType),
//     maxFeePerGas: BigInt(maxFeePerGas) * BigInt(feeType),
//     maxPriorityFeePerGas: BigInt(maxPriorityFeePerGas) * BigInt(feeType),
//   };
// }
